export function parseMapUrl() {
    const url = window.location.href
    let urlZoom, urlDb, urlLongitude, urlLatitude
    if (url?.indexOf('?') !== -1) {
        let queryParameters = url?.split('?')[1]
        const queryParametersParsed: any = new URLSearchParams(queryParameters);
        if (queryParametersParsed.has('zoom')) {
            urlZoom = queryParametersParsed.get('zoom')
        }
        if (queryParametersParsed.has('db')) {
            urlDb = queryParametersParsed.get('db')
        }
        if (queryParametersParsed.has('lon')) {
            urlLongitude = queryParametersParsed.get('lon')
        }
        if (queryParametersParsed.has('lat')) {
            urlLatitude = queryParametersParsed.get('lat')
        }
    }
    return { urlZoom, urlDb, urlLongitude, urlLatitude }
}